import React, { useState } from 'react';
import PropTypes from 'prop-types';

import AraraIcon from '../../AraraIcon';


const AraraIconButton = ({
  className,
  onClick,
  iconName,
  hoveredIconName,
}) => {
  const [hovered, setHover] = useState(false);
  return (
    <div
      className={className}
      role="button"
      tabIndex={0}
      onMouseEnter={() => { setHover(true); }}
      onMouseLeave={() => { setHover(false); }}
      onClick={onClick}
      onKeyPress={onClick}
    >
      <AraraIcon
        name={hovered ? hoveredIconName : iconName}
        noVariants
      />
    </div>
  );
};


AraraIconButton.defaultProps = {
  className: '',
};

AraraIconButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
  iconName: PropTypes.string.isRequired,
  hoveredIconName: PropTypes.string.isRequired,
};

export default AraraIconButton;
